import { useLocationStore } from '@elva/platform';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';

export function useLocationInvalidation() {
  const locationId = useLocationStore((s) => s.selectedCoreLocationId);
  const prevRef = useRef<number | null>(null);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (prevRef.current != null && prevRef.current !== locationId && locationId != null) {
      void queryClient.invalidateQueries({ queryKey: ['workspace'] });
      void queryClient.invalidateQueries({ queryKey: ['calendar'] });
      void queryClient.invalidateQueries({ queryKey: ['bird-eye'] });
      void queryClient.invalidateQueries({ queryKey: ['settings'] });
    }
    prevRef.current = locationId;
  }, [locationId, queryClient]);
}
